import React, { useState } from "react";

const FAQS = () => {
    const faqs = [
        {
            question: "How does ConRa's pricing works?",
            answer: "Getting started is simple: 1) Download the ConRa app from the App Store or Google Play, 2) create an account and sign in, 3) Create your first project. No credit card is required for the trial period.",
        },
        {
            question: "What form of payment do we accept?",
            answer: "We accept major credit cards, including Visa, MasterCard, and American Express. For Enterprise customers, we also support invoicing and wire transfers upon request. Payments are securely processed through our trusted payment gateways.",
        },
        {
            question: "How secure is ConRa?",
            answer: "Security is a top priority at ConRa. We use end-to-end encryption, secure data storage, and compliance tracking to ensure your information is safe. All data is transmitted over encrypted HTTPS connections, and we regularly update our security protocols to protect against potential threats.",
        },
        {
            question: "How do I cancel ConRa's subscription?",
            answer: "You can cancel your subscription at any time from your account settings. Once canceled, your plan will remain active until the end of the current billing cycle. If you need assistance, our support team is available to guide you through the process.",
        },
        {
            question: "What's our refund policy?",
            answer: "We offer a 7-day refund policy for new subscriptions. If you're unsatisfied with ConRa within the first 7 days, you can request a full refund. After this period, refunds are not provided, but you can cancel your subscription to prevent future charges.",
        },
    ];

    // Desktop: selected index (default first). Mobile: open/close accordion.
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section id="faqs">
            <div className="faq-container">
                <h2 className="h1-48-800">Your Questions, <span>Answered</span></h2>
                <p className="faq-description">
                    We've compiled a list of the most frequently asked questions about ConRa to help you get the information you need, feel free to reach out to our support team.
                </p>

                {/* ── Desktop two-column layout ── */}
                <div className="faq-qa-border">
                    <div className="faq-desktop">
                        <div className="faq-desktop-questions">
                            {faqs.map((faq, index) => (
                                <button
                                    key={index}
                                    className={`faq-desktop-q ${selectedIndex === index ? "faq-desktop-q--active" : ""}`}
                                    onClick={() => setSelectedIndex(index)}
                                >
                                    {faq.question}
                                </button>
                            ))}
                        </div>
                        <div className="faq-desktop-answer">
                            <p>{faqs[selectedIndex].answer}</p>
                        </div>
                    </div>

                    {/* ── Mobile accordion layout ── */}
                    <div className="faq-mobile">
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className={`faq-item ${openIndex === index ? "open" : ""}`}
                                onClick={() => toggleFAQ(index)}
                            >
                                <div className="faq-question">
                                    {faq.question}
                                    <span className="icon">{openIndex === index ? "−" : "+"}</span>
                                </div>
                                {openIndex === index && (
                                    <div className="faq-answer">{faq.answer}</div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>{/* end faq-qa-border */}

                <div className="faq-footer">
                    <p>Still have questions? We're here to help!</p>
                    <button className="faq-button">Contact Support</button>
                </div>
            </div>
        </section>
    );
};

export default FAQS;
